import { Stack, Typography } from '@mui/material';
import type { TypographyProps } from '@mui/material';
import { StrikethroughText } from '@tix-ticketing/ui-components';
import { FormattedPrice } from 'lib/helpers/formatted-price';

/** Whether two amounts differ once rounded to whole cents. */
export function isDiscounted(
  price: number,
  originalPrice: number | null | undefined
): originalPrice is number {
  return (
    originalPrice != null &&
    Math.round(originalPrice * 100) !== Math.round(price * 100)
  );
}

/** A price, with the struck-out original below it when it was discounted. */
export const DiscountedPrice = ({
  price,
  originalPrice,
  variant,
  originalVariant,
}: {
  price: number;
  originalPrice?: number | null;
  variant: TypographyProps['variant'];
  /** Variant of the struck-out original; defaults to `StrikethroughText`'s. */
  originalVariant?: TypographyProps['variant'];
}) => (
  <Stack sx={{ alignItems: 'flex-end' }}>
    <Typography variant={variant} sx={{ whiteSpace: 'nowrap' }}>
      <FormattedPrice amount={price} />
    </Typography>
    {isDiscounted(price, originalPrice) && (
      <StrikethroughText
        variant={originalVariant}
        sx={{ whiteSpace: 'nowrap' }}
      >
        <FormattedPrice amount={originalPrice} />
      </StrikethroughText>
    )}
  </Stack>
);
